module.exports = __webpack_public_path__ + "img/PHP.9328f6b9.png";